module.exports = __webpack_public_path__ + "img/2026-02-27a_1.205f5e93.jpg";